import React, { useState } from 'react';
import { Container, Row, Col, Card, Alert, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { authService } from '../services/api';
import { Formik } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  email: Yup.string()
    .required('Email is required')
    .email('Please enter a valid email address')
});

const ForgotPasswordPage = () => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setError(null);
      setSuccess(false);
      
      await authService.forgotPassword(values);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset email. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col md={6}>
          <Card className="p-4 shadow mt-5">
            <Card.Body>
              <h2 className="text-center mb-4">Forgot Password</h2>
              
              {error && <Alert variant="danger">{error}</Alert>}
              
              {success ? (
                <Alert variant="success">
                  <Alert.Heading>Check Your Email</Alert.Heading>
                  <p>
                    If your email exists in our system, you will receive a password reset link shortly.
                    Please check your inbox and spam folder.
                  </p>
                  <hr />
                  <div className="d-flex justify-content-between">
                    <Link to="/login">
                      <Button variant="outline-success">Back to Login</Button>
                    </Link>
                  </div>
                </Alert>
              ) : (
                <>
                  <p className="text-muted text-center mb-4">
                    Enter your email address and we'll send you a link to reset your password.
                  </p>
                  
                  <Formik
                    initialValues={{ email: '' }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                      <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                          <Form.Label>Email Address *</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.email && errors.email}
                            placeholder="your.email@example.com"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Button 
                          type="submit" 
                          variant="primary" 
                          className="w-100 mb-3" 
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                        </Button>
                      </Form>
                    )}
                  </Formik>
                  
                  <div className="text-center mt-3">
                    <Link to="/login" className="text-muted small">
                      Back to Login
                    </Link>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPasswordPage;
